import gql from "graphql-tag";

export default gql`
  mutation LoginWithGoogleAccessToken($accessToken: String!, $timeZone: String!) {
    loginWithGoogleAccessToken(accessToken: $accessToken, timeZone: $timeZone) {
      email
      isRecentlyCreatedUser
      accessToken
    }
  }
`;
